const encodeQueryParams = (obj, prefix) => {
  const str = [];
  let p;
  for (p in obj) {
    if (obj.hasOwnProperty(p) && obj[p] !== undefined) {
      let k;
      if (Object.prototype.toString.call(obj) === '[object Array]') {
        k = prefix ? `${prefix}[]` : p;
      } else {
        k = prefix ? `${prefix}[${p}]` : p;
      }
      const v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? encodeQueryParams(v, k)
          : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
      );
    }
  }
  return str.join('&');
};

export default encodeQueryParams;
